export const baseUrl = "https://huyentrangbeautycenter-api.vercel.app";

// export const baseUrl = "http://localhost:5500";